import { request } from 'http';
import { InjectModule, InjectVuexModule } from 'vue-di/vuex';
import _ from 'lodash';
import { Mutation, Action } from 'vuex-module-decorators';
import { ApigatewayApi, EdgeEnrollmentApi, EdgeSiteAccountApi, EdgeAccountApi, PayorV4Api } from '@trialcard/apigateway.client';
import moment from 'moment';
import { Resolve } from 'vue-di';
import {
    MedicalClaimSearchResponseModel,
    PharmacyClaimSearchResponseModel,
    EnrollmentModel,
    PrescriberModel,
    PatientsSearchPatientsRequestModel,
} from '@trialcard/apigateway.models';
// ScriptsSiteAccountV2PatientsPatientAccountModel
import { EnrollmentV2PaymentTypeModel } from '@trialcard/apigateway.models/enrollmentV2PaymentTypeModel';
import {
    AccountExternalIdType,
    AccountRoleType,
    EnrollmentType,
    EnrollmentStatus,
    Gender,
    CaseExternalIdType,
    ExternalIdType,
    AlternateCardType,
} from '@trialcard/enums';
import * as enums from '@trialcard/enums';
import data from 'pdfkit/js/data';
import { async } from 'rxjs';
import { number, boolean } from 'yargs';
import AccountModule from './account';
import { TcPatientAccountDetailsModel, PatientAccountDisplayDetails } from './interfaces';
import SessionModule from './session';
import enrollment from './enrollment';
import { SearchFields } from '~/components/patient/searchFields';
import { PatientSearchUniqueIdenitfierType, SearchEnrollmentStatus } from '~/types/searchTypes';
import { Settings } from '~/services/settings';
import gender from '~/assets/gender';
import CommonTools from '~/components/tools/commonTools';

@InjectModule({ stateFactory: true }, module)
// @OnClear<SearchModule>(async value => value.clear())
export default class SearchModule extends InjectVuexModule {
    @Resolve
    siteAccountApi!: EdgeSiteAccountApi;
    @Resolve
    accountApi!: EdgeAccountApi;
    @Resolve
    accountModule!: AccountModule;
    @Resolve
    session!: SessionModule;
    @Resolve
    apiGateWay!: ApigatewayApi;
    @Resolve
    enrollmentApi!: EdgeEnrollmentApi;

    @Resolve
    payorApi!: PayorV4Api;

    @Resolve
    public settings!: Settings;

    results!: any[];
    currentPatient!: PatientAccountDisplayDetails;
    currentEdit: any;
    currentDelete: any;
    paymentMethods!: EnrollmentV2PaymentTypeModel[];
    hubSearchResultPrescribers: PrescriberModel[] = [];

    setCurrentEdit(item: any): void {
        this.currentEdit = item;
    }
    setCurrentDelete(item: any): void {
        this.currentDelete = item;
    }
    getCurrentEdit() {
        return this.currentEdit;
    }
    setCurrentPatient(patient: PatientAccountDisplayDetails): void {
        this.currentPatient = patient;
    }
    getCurrentPatient() {
        return this.currentPatient;
    }

    @Mutation
    clearResults(): void {
        this.results = [];
        this.currentPatient = {} as PatientAccountDisplayDetails;
    }

    async callSearchApi(search: SearchFields, programId: number) {
        const requestLC = {
            maxRecordCount: 5000,
            firstName: CommonTools.safeStringTrim(search.firstName),
            lastName: CommonTools.safeStringTrim(search.lastName),
            dateOfBirth: (search.dateOfBirth || '').length <= 0 ? undefined : moment.utc(search.dateOfBirth || '', ['MM/DD/YYYY', 'YYYY-MM-DD']).add(12, 'hours'),
        } as PatientsSearchPatientsRequestModel;

        if (search.memberNumber && search.memberNumber.length > 0) {
            requestLC.accountExternalIdType = AccountExternalIdType.MedMemberID;
            requestLC.accountExternalId = CommonTools.safeStringTrim(search.memberNumber);
        } else if (search.alternateId && search.alternateId.length > 0) {
            requestLC.accountExternalIdType = AccountExternalIdType.THIRDPARTYID;
            requestLC.accountExternalId = CommonTools.safeStringTrim(search.alternateId);
        } else if (search.pharmacyMemberNumber && search.pharmacyMemberNumber.length > 0) {
            requestLC.accountExternalIdType = AccountExternalIdType.PharMemberID;
            requestLC.accountExternalId = CommonTools.safeStringTrim(search.pharmacyMemberNumber);
        }

        try {
            const response = await this.siteAccountApi.patientsSearchAllProgramPatients(requestLC, programId.toString());
            const results = response.data && response.data.data;
            const resp = await Promise.all(
                results.map(async item => {

                    let medPayor, pharmPayor;
                    if(item.account!.payors) {
                        medPayor = item.account!.payors.find(x => {
                            if (x.roleType == 3) return x;
                            else return undefined;
                        });
                        pharmPayor = item.account!.payors.find(x => {
                            if (x.roleType === 4) return x;
                            else return undefined;
                        });
                    }
                    const medPayorId = medPayor?.accountRelations![0].relatedId;
                    const pharmPayorId = pharmPayor?.accountRelations![0].relatedId;
                    let medicalPolicyId, pharmacyPolicyId, payorName, payorPhone, insuranceBin, insurancePcn;
                    let siteFaxNumberExist = false;
                    if(item.account && item.account.sites && item.account.sites.length > 0 &&item.account.sites[0].relatedId){
                        const siteApiResult = await  this.apiGateWay.edgeAccount.sitesHubGetSites({siteIds:[
                            item.account?.sites[0].relatedId
                        ]} )
                        if(siteApiResult.data.data[0].phoneNumbers)
                        siteFaxNumberExist = siteApiResult.data.data[0].phoneNumbers.filter(x=>x.phoneType === 3).length > 0
                    }
                    if (item.account!.accountId && medPayorId) {
                        const medResponse = await this.payorApi.accountMedicalGet2(item.account!.accountId, medPayorId);
                        const data = medResponse.data && medResponse.data.data;
                        medicalPolicyId = data?.policyNumber;
                        payorName = data?.name ? data.name : data?.policyName;
                        payorPhone = data?.phone;
                    }
                    if (item.account!.accountId && pharmPayorId) {
                        const pharmResponse = await this.payorApi.accountPharmacyGet2(item.account!.accountId, pharmPayorId);
                        const data = pharmResponse.data && pharmResponse.data.data;
                        pharmacyPolicyId = data?.policyNumber;
                        insuranceBin = data?.bin;
                        insurancePcn = data?.pcn;
                    }
                    const externalIds = item?.account?.externalIds || [];
                    const pharmacyMemberNumber = externalIds.find(
                        (x: any) => x?.externalIdType === AccountExternalIdType.PharMemberID
                        )?.externalId || '';
                    const medicalMemberNumber = externalIds.find(
                        (x: any) => x?.externalIdType === AccountExternalIdType.MedMemberID
                        )?.externalId || '';
                    return {
                        accountId: item.account!.accountId,
                        displayId: item.account!.displayId,
                        firstName: item.patient!.firstName,
                        lastName: item.patient!.lastName,
                        dateOfBirth: item.patient!.dateOfBirth,
                        gender: item.patient!.gender,
                        address1: item.patient!.addresses!.length > 0 ? item.patient!.addresses![0].addressOne : '',
                        address2: item.patient!.addresses!.length > 0 ? item.patient!.addresses![0].addressTwo : '',
                        city: item.patient!.addresses!.length > 0 ? item.patient!.addresses![0].city : '',
                        state: item.patient!.addresses!.length > 0 ? item.patient!.addresses![0].state : '',
                        postalCode: item.patient!.addresses!.length > 0 ? item.patient!.addresses![0].zip : '',
                        country: item.patient!.addresses!.length > 0 ? item.patient!.addresses![0].country : '',
                        memberNumber: pharmacyMemberNumber || medicalMemberNumber ,
                        cardStartDate: undefined,
                        cardEndDate: undefined,
                        cardActivationDate: undefined,
                        eligibilityStatusCode: undefined,
                        eligibilityStatusDescription: undefined,
                        eligibilityDate: undefined,
                        bin: undefined,
                        sponsorNumber: undefined,
                        alternateCardIds: [
                            {
                                alternateCardNumber: item.account!.externalIds!.find(x => {
                                    if (x.externalIdType === AccountExternalIdType.THIRDPARTYID) return x;
                                    else return '';
                                })?.externalId,
                                cardAlternateIdType: AlternateCardType.ThirdPartyID,
                            },
                        ],
                        email: item.patient!.emailAddresses!.length > 0 ? item.patient!.emailAddresses![0].address : '',
                        phone: item.patient!.phoneNumbers!.length > 0 ? item.patient!.phoneNumbers![0].phoneNumber : '',
                        groupNumber: '-',
                        totalBenefitAmount: 0,
                        remainingBenefitAmount: 0,
                        totalPaidAmount: 0,
                        accumulators: [],
                        communicationTypes: item.account!.contactPreferences,
                        insuranceType: undefined,
                        payerName: payorName,
                        payerPhone: payorPhone,
                        patientInsuranceBin: insuranceBin,
                        patientInsurancePcn: insurancePcn,
                        payerMedicalId: medicalPolicyId,
                        payerPharmacyId: pharmacyPolicyId,
                        siteFaxNumberExist,
                        // Display values (member #, group #, status) are sourced from the
                        // getBestEnrollmentV2 result and merged in by the patient search page.
                        // Default to '-' until that merge runs.
                        status: '-',
                        pharmacyMemberNumber: '-',
                        medicalMemberNumber,
                    };
                })
            );
            return resp.map((x: any) => x) || [];
        } catch {
            return;
        }
    }


    @Mutation
    setHubSearchResultPrescribers(data: PrescriberModel[]) {
        this.hubSearchResultPrescribers = data;
    }

    setResults(results: any[]): void {
        if (results != null) {
            this.results = results.filter(item => item != null);
        }
    }


    async getSearchResults(request: SearchFields, programId: number, isEmptyRequest = false, isUnchanged: boolean, isMaxResults = false) {
        if (!isUnchanged || (isEmptyRequest && this.results.length <= 0) || isMaxResults) {
            await this.callSearchApi(request, programId)
                .then(data => {
                    const convertedData = (data || []).map((item: any) => {
                        item.dateOfBirth = moment.utc(item.dateOfBirth || '').format('L')
                        if (_.isString(item.address1)) {
                            const index = item.address1.lastIndexOf(', ');
                            if (index >= 0) {
                                item.address2 = item.address1.slice(index + 2, item.address1.length);
                                item.address1 = item.address1.slice(0, index);
                            }
                        }
                        if (item.alternateCardIds && item.alternateCardIds.length > 0) {
                            const altId = item.alternateCardIds[0];
                            item.alternateId =
                                altId.alternateCardNumber && altId.cardAlternateIdType === enums.AlternateCardType.ThirdPartyID
                                    ? altId.alternateCardNumber
                                    : '';
                        }
                        return item;
                    });
                   this.setResults(convertedData || []);
                    return this.results;
                })
                .catch(error => {
                    throw error;
                });
        }

        return isEmptyRequest ? this.results : this.getFilteredResults(request, true, false);
    }

    getFilteredResults(request: SearchFields, isCamelCase = true, isPascalCase?: boolean) {
        const fieldKeys: string[] = Object.keys(request);
        const filterFields: string[] = fieldKeys.filter(item => request[item] && CommonTools.safeToString(request[item]).length > 0);
        const returnResults = (this.results || []).filter(item => {
            let valid = true;
            filterFields.forEach(key => {
                const keyName = isCamelCase ? _.camelCase(key) : isPascalCase ? CommonTools.pascalCase(key) : key;
                if (
                    item &&
                    (!item[keyName] ||
                        (item[keyName] &&
                            !CommonTools.safeToStringLowerCase(item[keyName]).includes(CommonTools.safeToStringLowerCase(request[key]))))
                ) {
                    valid = false;
                }
            });
            return valid;
        });

        return returnResults;
    }

    private async getPatientAccountDetails(
        patientAccount: any
    ): Promise<PatientAccountDisplayDetails> {
        // Get the patient's enrollment
        const enrollment = await this.accountModule
            .getEnrollment(
                {
                    patient : {
                    ...patientAccount.patient,
                    zip:
                        patientAccount.patient.addresses &&
                        patientAccount.patient.addresses.length > 0 &&
                        patientAccount.patient.addresses[0].zip!,
                    },
                    arrOp : false
                }
            )
            .then((response: any) => {
                return response;
            })
            .catch(() => {
                return undefined;
            });

        // Find Primary Medical Payor from payorlist
        const medicalPayors =
            patientAccount.account.payors &&
            patientAccount.account.payors.length > 0 &&
            patientAccount.account.payors.find((py: { roleType: AccountRoleType; }) => py.roleType === AccountRoleType.InsuranceProvider);
        const primaryMedicalPayor =
            (medicalPayors && medicalPayors.accountRelations && medicalPayors.accountRelations.find((x: { coverageOrder: number; }) => x.coverageOrder === 1)) || {};
        const patientAccountDetails = {
            patientAccount,
            enrollment,
        } as TcPatientAccountDetailsModel;
        return this.mapToPatientAccountDisplay(patientAccountDetails);
    }

    @Action({})
    async getClaims(enrollment: EnrollmentModel) {
        const enrollmentMedicalClaims: MedicalClaimSearchResponseModel[] = [];
        const enrollmentPharmacyClaims: PharmacyClaimSearchResponseModel[] = [];
        if (enrollment) {
            // Get Claims
            const medicalMemberNumber = enrollment.memberNumbers.find(x => {
                return x.type === EnrollmentType.Medical;
            });
            const pharmacyMemberNumber = enrollment.memberNumbers.find(x => {
                return x.type === EnrollmentType.Pharmacy;
            });
            if (medicalMemberNumber) {
                const medicalClaims = await this.accountModule.getMedicalClaims(medicalMemberNumber.number!);
                enrollmentMedicalClaims.push(...medicalClaims);
            }
            if (pharmacyMemberNumber) {
                const pharmacyClaims = await this.accountModule.getPharmacyClaims(pharmacyMemberNumber.number!);
                enrollmentPharmacyClaims.push(...pharmacyClaims);
            }
        }
        return {
            claims: [...enrollmentMedicalClaims, ...enrollmentPharmacyClaims],
        };
    }

    @Action
    async ResendSignatureRequest(accountId: number): Promise<boolean> {
        const request = {
            accountId,
        };

        const isSuccessful = await this.apiGateWay.edgeSignature
            .envelopeResendLatest(request)
            .then(res => {
                if (res.data && res.data.success) {
                    return true;
                } else {
                    return false;
                }
            })
            .catch(() => {
                return false;
            });

        return isSuccessful;
    }

    private mapToPatientAccountDisplay(patientAccountDetails: TcPatientAccountDetailsModel): PatientAccountDisplayDetails {
        const patient = patientAccountDetails.patientAccount.patient;
        const enrollment = patientAccountDetails.enrollment;
        const medicalMemberNumber =
            enrollment &&
            enrollment!.memberNumbers.find(x => {
                return x.type === EnrollmentType.Medical;
            });
        const pharmacyMemberNumber =
            enrollment &&
            enrollment!.memberNumbers.find(x => {
                return x.type === EnrollmentType.Pharmacy;
            });
        const address = patient!.addresses && patient!.addresses.length > 0 && patient!.addresses[0] ? patient!.addresses[0] : undefined;
        const enrollmentType = (enrollment && enrollment.bestEnrollmentType) || '';
        const enrollmentStatus =
            (enrollment && enrollment.status && Number(enrollment.status.status) >= 0 && EnrollmentStatus[enrollment.status.status!]) ||
            enrollmentType;
        const enrollmentStatusDisplay =
            (enrollment &&
                enrollment.status &&
                Number(enrollment.status.status) >= 0 &&
                SearchEnrollmentStatus[enrollment.status.status!]) ||
            enrollmentType;

        return {
            patientId: patient!.patientId,
            firstName: patient!.firstName,
            lastName: patient!.lastName,
            dateOfBirth: patient!.dateOfBirth && moment(patient!.dateOfBirth).format('L'),
            addressDisplay: `${address && address.addressOne} ${address && address.city}, ${address && address.state} ${address &&
                address.zip}`,
            addresses: patient!.addresses,
            addressOne: address && address.addressOne,
            addressTwo: address && address.addressTwo,
            city: address && address.city,
            state: address && address.state,
            zipCode: address && address.zip,
            gender: patient!.gender ? this.getGender(patient!.gender.valueOf()) : '',
            genderValue: patient!.gender || 0,
            aobFlag: patientAccountDetails.patientAccount.account!.assignmentOfBenefitFlag ? 'Y' : 'N',
            accountId: patientAccountDetails.patientAccount.account!.displayId,
            accountIdNumber: patientAccountDetails.patientAccount.account!.accountId,
            lashID:
            (
                patientAccountDetails.patientAccount.account!.externalIds!.find(item => {
                    return item.externalIdType === AccountExternalIdType.THIRDPARTYID.valueOf();
                }) || {}
            ).externalId || '',
            thirdPartyId:
                (
                    patientAccountDetails.patientAccount.account!.externalIds!.find(item => {
                        return item.externalIdType === AccountExternalIdType.THIRDPARTYID.valueOf();
                    }) || {}
                ).externalId || '',
            medicalMemberId: medicalMemberNumber && medicalMemberNumber.number,
            paymentType:
                ((this.paymentMethods || []).find(item => (enrollment || {}).paymentType === item.paymentTypeId) || {})
                    .paymentTypeDescription || '',
            pharmacyMemberId: pharmacyMemberNumber && pharmacyMemberNumber.number,
            sites: patientAccountDetails.patientAccount.account!.sites,
            enrollmentEndDate: enrollment && enrollment.endDate && moment(enrollment.endDate).format('L'),
            enrollmentStartDate: enrollment && enrollment.startDate && moment(enrollment.startDate).format('L'),
            enrollment: enrollment || {},
            phoneNumbers: patient!.phoneNumbers,
            emailAddresses: patient!.emailAddresses,
            enrollmentStatus,
            enrollmentStatusDisplay,
            enrollmentType,

        } as PatientAccountDisplayDetails;
    }

    getGender(gender: number) {
        let result;
        switch (gender) {
            case Gender.UNKN:
                result = 'Unkown';
                break;
            case Gender.M:
                result = 'Male';
                break;
            case Gender.F:
                result = 'Female';
                break;
            case Gender.I:
                result = 'Indeterminate';
                break;
        }
        return result;
    }

    getExternalIdType(uniqueIdType: PatientSearchUniqueIdenitfierType) {
        let result;
        switch (uniqueIdType) {
            case PatientSearchUniqueIdenitfierType.MedicalMemberId:
                result = AccountExternalIdType.MedMemberID;
                break;
            case PatientSearchUniqueIdenitfierType.PharmacyMemberId:
                result = AccountExternalIdType.PharMemberID;
                break;
            case PatientSearchUniqueIdenitfierType.AccountNumber:
                result = AccountExternalIdType.TrialCardHubId;
                break;
            case PatientSearchUniqueIdenitfierType.AlternateId:
                result = AccountExternalIdType.THIRDPARTYID;
                break;
        }
        return result;
    }


    // @Action({})
    // async getPaymentTypes() {
    //     try {
    //         const paymentMethods = await this.enrollmentApi.paymentPaymentMethod();

    //         this.paymentMethods = (((paymentMethods || {}).data || {}).data || {}).data;

    //         return this.paymentMethods;
    //     } catch (error) {
    //         return [];
    //     }
    // }
}
